import React, { useState, useRef, useEffect } from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  IconButton,
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import StepperSchedule from '../../components/StepperSchedule';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import phoneIcon from '../../../assets/images/phone_icon.svg';
import DirectionsIcon from '@mui/icons-material/Directions';
import CalendarIcon from '../../../assets/images/calendar2_icon.svg';
import LocationIcon from '../../../assets/images/location_icon.svg';
import ClockIcon from '../../../assets/images/clock2_icon.svg';
import { ROUTES } from '../constants/routes';

// Crie um componente para controlar o movimento do mapa
const MapController = ({ coordinates }) => {
  const map = useMap();
  
  React.useEffect(() => {
    map.flyTo(coordinates, 13, {
      duration: 1.5, // Duração da animação em segundos
      easeLinearity: 0.25
    });
  }, [coordinates, map]);

  return null;
};

// Função para buscar coordenadas a partir do endereço
const getCoordinates = async (address) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`
    );
    const data = await response.json();
    
    if (data && data[0]) {
      return [parseFloat(data[0].lat), parseFloat(data[0].lon)];
    }
    return null;
  } catch (error) {
    console.error('Erro ao buscar coordenadas:', error);
    return null;
  }
};

const Schedule = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const scrollContainerRef = useRef(null);
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isMdScreen = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const { id } = useParams();
  const [selectedLocation, setSelectedLocation] = useState(0);
  const [selectedTime, setSelectedTime] = useState(null);
  const [locations, setLocations] = useState([
    {
      id: 1,
      name: 'Auto Parvi - Afogados',
      phone: '4020-7755',
      address: 'Rua João Ivo da Silva, 220, Madalena, Recife, PE',
      coordinates: [-8.0578, -34.9066],
      availableTimes: {
        '01-Abr': ['09:00', '10:00', '11:00', '14:00', '15:00'],
        '02-Abr': ['10:00', '11:00', '14:00', '16:00'],
        '03-Abr': ['09:00', '11:00', '15:00', '16:00'],
        '04-Abr': ['08:00', '10:00', '14:00', '15:00'],
        '05-Abr': ['09:00', '10:00', '11:00', '14:00'],
        '06-Abr': ['10:00', '11:00', '14:00'],
        '07-Abr': ['09:00', '10:00', '11:00'],
        '08-Abr': ['09:00', '10:00', '14:00', '15:00'],
        '09-Abr': ['10:00', '11:00', '14:00', '16:00'],
        '10-Abr': ['09:00', '11:00', '15:00'],
        '11-Abr': ['08:00', '10:00', '14:00'],
        '12-Abr': ['09:00', '10:00', '14:00', '15:00'],
        '13-Abr': ['10:00', '11:00', '14:00']
      }
    },
    {
      id: 2,
      name: 'Auto Parvi - Olinda',
      phone: '4020-7755',
      address: 'Avenida Pan Nordestina, 731, Salgadinho, Olinda, PE',
      coordinates: [-8.0578, -34.9066],
      availableTimes: {
        '01-Abr': ['08:00', '09:30', '11:30', '13:00', '15:30'],
        '02-Abr': ['08:30', '10:30', '13:30', '16:30'],
        '03-Abr': ['08:00', '10:00', '13:00', '15:00'],
        '04-Abr': ['09:30', '11:30', '14:30', '16:30'],
        '05-Abr': ['08:00', '09:30', '13:00', '15:30'],
        '06-Abr': ['09:30', '11:30', '14:30'],
        '07-Abr': ['08:00', '10:00', '13:00'],
        '08-Abr': ['08:00', '09:30', '13:00', '15:30'],
        '09-Abr': ['08:30', '10:30', '13:30', '16:30'],
        '10-Abr': ['08:00', '10:00', '13:00', '15:00'],
        '11-Abr': ['09:30', '11:30', '14:30'],
        '12-Abr': ['08:00', '09:30', '13:00', '15:30'],
        '13-Abr': ['09:30', '11:30', '14:30']
      }
    },
    {
      id: 3,
      name: 'Auto Parvi - Rui Barbosa',
      phone: '4020-7755',
      address: 'Avenida Rui Barbosa, 1105, Graças, Recife, PE',
      coordinates: [-8.0578, -34.9066],
      availableTimes: {
        '01-Abr': ['07:00', '09:00', '12:00', '14:00', '17:00'],
        '02-Abr': ['07:30', '09:30', '12:30', '15:30'],
        '03-Abr': ['07:00', '09:00', '12:00', '16:00'],
        '04-Abr': ['08:30', '10:30', '13:30', '17:30'],
        '05-Abr': ['07:00', '09:00', '12:00', '15:00'],
        '06-Abr': ['08:30', '10:30', '13:30'],
        '07-Abr': ['07:00', '09:00', '12:00'],
        '08-Abr': ['07:00', '09:00', '12:00', '15:00'],
        '09-Abr': ['07:30', '09:30', '12:30', '15:30'],
        '10-Abr': ['07:00', '09:00', '12:00', '16:00'],
        '11-Abr': ['08:30', '10:30', '13:30'],
        '12-Abr': ['07:00', '09:00', '12:00', '15:00'],
        '13-Abr': ['08:30', '10:30', '13:30']
      }
    }
  ]);
  
  const scheduledInspections = [
    {
      id: 1,
      day: '01',
      month: 'Abr',
      weekDay: 'Seg'
    },
    {
      id: 2, 
      day: '02',
      month: 'Abr',
      weekDay: 'Ter'
    },
    {
      id: 3,
      day: '03',
      month: 'Abr', 
      weekDay: 'Qua'
    },
    {
      id: 4,
      day: '04',
      month: 'Abr',
      weekDay: 'Qui'
    },
    {
      id: 5,
      day: '05',
      month: 'Abr',
      weekDay: 'Sex'
    },
    {
      id: 6,
      day: '06',
      month: 'Abr',
      weekDay: 'Sáb'
    },
    {
      id: 7,
      day: '07',
      month: 'Abr',
      weekDay: 'Dom'
    },
    {
      id: 8,
      day: '08',
      month: 'Abr',
      weekDay: 'Seg'
    },
    {
      id: 9,
      day: '09',
      month: 'Abr',
      weekDay: 'Ter'
    },
    {
      id: 10,
      day: '10',
      month: 'Abr',
      weekDay: 'Qua'
    },
    {
      id: 11,
      day: '11',
      month: 'Abr',
      weekDay: 'Qui'
    },
    {
      id: 12,
      day: '12',
      month: 'Abr',
      weekDay: 'Sex'
    },
    {
      id: 13,
      day: '13',
      month: 'Abr',
      weekDay: 'Sáb'
    }
  ];

  const location = useLocation();
  const { licensePlate, price, planType } = location.state || {};

  const [selectedDate, setSelectedDate] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAllCoordinates = async () => {
      const updatedLocations = await Promise.all(
        locations.map(async (location) => {
          const coordinates = await getCoordinates(location.address);
          return {
            ...location,
            coordinates: coordinates || [-8.0578, -34.9066] // Coordenada padrão caso falhe
          };
        })
      );
      setLocations(updatedLocations);
    };

    fetchAllCoordinates();
  }, []);

  const getCardsPerView = () => {
    if (isXsScreen) return 4;
    if (isSmScreen) return 5;
    if (isMdScreen) return 6;
    return 7;
  };

  const cardsPerView = getCardsPerView();
  const totalSlides = Math.ceil(scheduledInspections.length / cardsPerView);

  const handleNext = () => {
    if (scrollContainerRef.current) {
      const newSlide = Math.min(currentSlide + 1, totalSlides - 1);
      setCurrentSlide(newSlide);
      const slideWidth = scrollContainerRef.current.offsetWidth;
      scrollContainerRef.current.scrollTo({
        left: newSlide * slideWidth,
        behavior: 'smooth'
      });
    }
  };

  const handlePrev = () => {
    if (scrollContainerRef.current) {
      const newSlide = Math.max(currentSlide - 1, 0);
      setCurrentSlide(newSlide);
      const slideWidth = scrollContainerRef.current.offsetWidth;
      scrollContainerRef.current.scrollTo({
        left: newSlide * slideWidth,
        behavior: 'smooth'
      });
    }
  };

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const slideWidth = scrollContainerRef.current.offsetWidth;
      const newSlide = Math.round(scrollContainerRef.current.scrollLeft / slideWidth);
      setCurrentSlide(newSlide);
    }
  };

  // Criar o ícone personalizado usando MUI
  const customIcon = L.divIcon({
    className: 'custom-marker-icon',
    html: `<svg style="color: #51DF94; width: 32px; height: 32px;" focusable="false" aria-hidden="true" viewBox="0 0 24 24">
             <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"></path>
           </svg>`,
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32]
  });

  // Adicione essa função para formatar a data por extenso
  const formatDateToExtensive = (day, month) => {
    const months = {
      'Jan': 'Janeiro',
      'Fev': 'Fevereiro',
      'Mar': 'Março',
      'Abr': 'Abril',
      'Mai': 'Maio',
      'Jun': 'Junho',
      'Jul': 'Julho',
      'Ago': 'Agosto',
      'Set': 'Setembro',
      'Out': 'Outubro',
      'Nov': 'Novembro',
      'Dez': 'Dezembro'
    };
    return `${day} de ${months[month]} de 2024`;
  };

  const monthsToNumber = {
    'Jan': '01', 'Fev': '02', 'Mar': '03', 'Abr': '04', 'Mai': '05', 'Jun': '06',
    'Jul': '07', 'Ago': '08', 'Set': '09', 'Out': '10', 'Nov': '11', 'Dez': '12'
  };

  // Função para obter a chave de data formatada
  const getFormattedDateKey = (date) => {
    if (!date) return null;
    return `${date.day}-${date.month}`;
  };

  const handleScheduling = async () => {
    if (!selectedDate || !selectedTime || !locations[selectedLocation]) return;

    const currentYear = new Date().getFullYear();
    const selectedMonth = parseInt(monthsToNumber[selectedDate.month]);
    const currentMonth = new Date().getMonth() + 1;
    const year = selectedMonth < currentMonth ? currentYear + 1 : currentYear;
    
    // Formata a data e hora juntas no formato ISO
    const formattedDate = `${year}-${monthsToNumber[selectedDate.month]}-${selectedDate.day.padStart(2, '0')}`;
    const formattedDateTime = `${formattedDate} ${selectedTime}:00`;

    const schedulingData = {
      datetime: formattedDateTime, // Data e hora combinadas
      address: locations[selectedLocation].address,
      center_name: locations[selectedLocation].name
    };

    navigate(`${ROUTES.PAYMENT}/${id}`, { 
      replace: true,
      state: { 
        licensePlate,
        price,
        planType,
        scheduling: schedulingData
      } 
    });
  };

  return (
    <Box sx={{ bgcolor: '#F5F7F9', display: 'flex', flexDirection: 'column' }}>
      <Container maxWidth="xl" sx={{ flex: 1, py: 2, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ 
          maxWidth: '1100px', 
          width: '100%',
          mx: 'auto',
          px: { xs: 2, md: 4 }
        }}>
          <Box sx={{ py: 4 }}>
            <Typography 
              variant="h4" 
              component="h1" 
              align="center" 
              sx={{ mb: 4, fontWeight: 600, color: '#012F47' }}
            >
              Agendar Autovalid 360
            </Typography>

            <StepperSchedule currentStep={1} />
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 400, mb: 1.5, color: '#012F47' }}>
              Escolha uma data disponível
            </Typography>

            <Box sx={{ 
              bgcolor: 'white',
              borderRadius: 2,
              py: 3,
              px: { xs: 3, md: 4 },
              overflow: 'hidden',
              position: 'relative'
            }}>
              {scheduledInspections.length > 5 && (
                <>
                  {currentSlide > 0 && (
                    <IconButton
                      onClick={handlePrev}
                      sx={{
                        position: 'absolute',
                        left: { xs: 0, md: 0 },
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: 32,
                        height: 32,
                        '&:hover': { 
                          bgcolor: 'transparent'
                        },
                        zIndex: 2,
                        color: '#012F47'
                      }}
                    >
                      <KeyboardArrowLeftIcon sx={{ fontSize: 24 }} />
                    </IconButton>
                  )}
                  
                  {currentSlide < totalSlides - 1 && (
                    <IconButton
                      onClick={handleNext}
                      sx={{
                        position: 'absolute',
                        right: { xs: 0, md: 0 },
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: 32,
                        height: 32,
                        '&:hover': { 
                          bgcolor: 'transparent'
                        },
                        zIndex: 2,
                        color: '#012F47'
                      }}
                    >
                      <KeyboardArrowRightIcon sx={{ fontSize: 24 }} />
                    </IconButton>
                  )}
                </>
              )}

              <Box
                ref={scrollContainerRef}
                onScroll={handleScroll}
                sx={{
                  display: 'flex',
                  gap: 2,
                  overflowX: 'hidden',
                  scrollSnapType: 'x mandatory',
                  '&::-webkit-scrollbar': { display: 'none' },
                  msOverflowStyle: 'none',
                  scrollbarWidth: 'none',
                  position: 'relative',
                  py: 1,
                  pl: { xs: 4, md: 5 },
                  pr: { xs: 4, md: 5 },
                  width: '100%',
                  justifyContent: 'flex-start'
                }}
              >
                {scheduledInspections.map((inspection) => (
                  <Paper 
                    key={inspection.id}
                    elevation={0}
                    onClick={() => setSelectedDate(inspection)}
                    sx={{
                      width: { 
                        xs: `calc((100% - ${4 * 16}px) / 4)`,
                        sm: `calc((100% - ${5 * 16}px) / 5)`,
                        md: `calc((100% - ${6 * 16}px) / 6)`,
                        lg: `calc((100% - ${7 * 16}px) / 7)`
                      },
                      height: { xs: 60, sm: 70 },
                      minWidth: { xs: 65, sm: 70 },
                      maxWidth: { xs: 70, sm: 75 },
                      bgcolor: selectedDate?.id === inspection.id ? '#51DF94' : 'white',
                      color: selectedDate?.id === inspection.id ? 'white' : '#012F47',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: 2,
                      border: '2px solid #012F47',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease-in-out',
                      scrollSnapAlign: 'start',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: 3
                      },
                      '& .MuiTypography-root': {
                        color: selectedDate?.id === inspection.id ? 'white' : '#012F47'
                      }
                    }}
                  >
                    <Typography 
                      variant="h4" 
                      sx={{ 
                        fontWeight: 700, 
                        color: '#012F47',
                        lineHeight: 1,
                        fontSize: { xs: '1.3rem', sm: '1.5rem' },
                        mb: -0.2
                      }}
                    >
                      {inspection.day}
                    </Typography>
                    <Typography 
                      variant="h6" 
                      sx={{ 
                        fontWeight: 700,
                        color: '#012F47',
                        fontSize: { xs: '0.8rem', sm: '0.9rem' },
                        lineHeight: 1.2
                      }}
                    >
                      {inspection.month}
                    </Typography>
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        color: '#012F47',
                        mt: 0.3,
                        fontSize: { xs: '0.6rem', sm: '0.7rem' },
                        fontWeight: 400,
                        lineHeight: 1
                      }}
                    >
                      {inspection.weekDay}
                    </Typography>
                  </Paper>
                ))}
              </Box>
            </Box>
          </Box>

          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 400, mb: 1.5, color: '#012F47' }}>
              Escolha o melhor local e horário para você
            </Typography>

            <Box sx={{ 
              bgcolor: 'white',
              borderRadius: 2,
              p: { xs: 2, md: 3 },
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: 3,
              height: { xs: 'auto', md: '500px' },
              width: '100%',
              position: 'relative'
            }}>
              <Box sx={{ 
                width: { xs: '100%', md: '40%' },
                overflowY: 'auto',
                pr: 2,
                position: 'relative',
                height: '100%'
              }}>
                {locations.map((location, index) => (
                  <Paper
                    key={location.id}
                    elevation={0}
                    onClick={() => setSelectedLocation(index)}
                    sx={{
                      p: 2,
                      mb: 2,
                      cursor: 'pointer',
                      border: '1px solid',
                      borderColor: selectedLocation === index ? '#51DF94' : '#E0E0E0',
                      borderRadius: 2,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        borderColor: '#51DF94',
                        transform: 'translateX(4px)'
                      }
                    }}
                  >
                    <Typography 
                      sx={{ 
                        fontWeight: 600,
                        color: '#51DF94',
                        mb: 1,
                      }}
                    >
                      {location.name}
                    </Typography>
                    
                    <Typography 
                      sx={{ 
                        color: '#536777',
                        mb: 1,
                        fontSize: '0.9rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                      }}
                    >
                      <img 
                        src={phoneIcon} 
                        alt="Telefone"
                        style={{
                          width: '16px',
                          height: '16px',
                          objectFit: 'contain'
                        }}
                      />
                      {location.phone}
                    </Typography>
                    
                    <Typography 
                      sx={{ 
                        color: '#536777',
                        fontSize: '0.9rem',
                        lineHeight: 1.4
                      }}
                    >
                      {location.address}
                    </Typography>

                    {/* Renderiza os horários disponíveis apenas se uma data for selecionada */}
                    {selectedDate && location.availableTimes[getFormattedDateKey(selectedDate)] && (
                      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
                        {location.availableTimes[getFormattedDateKey(selectedDate)].map((time) => (
                          <Paper
                            key={time}
                            onClick={(e) => {
                              e.stopPropagation(); // Evita que o clique propague para o card pai
                              setSelectedLocation(index);
                              setSelectedTime(time);
                            }}
                            sx={{
                              padding: '4px 8px',
                              cursor: 'pointer',
                              borderRadius: '4px',
                              border: selectedLocation === index && selectedTime === time ? '2px solid #51DF94' : '2px solid transparent',
                              backgroundColor: selectedLocation === index && selectedTime === time ? '#51DF94' : '#f5f5f5',
                              color: selectedLocation === index && selectedTime === time ? 'white' : '#012F47',
                              transition: 'all 0.2s ease',
                              '&:hover': {
                                backgroundColor: selectedLocation === index && selectedTime === time ? '#00B26C' : '#e0e0e0',
                              },
                            }}
                          >
                            <Typography sx={{ fontWeight: 500, fontSize: '0.8rem' }}>
                              {time}
                            </Typography>
                          </Paper>
                        ))}
                      </Box>
                    )}
                  </Paper>
                ))}
              </Box>

              <Box sx={{ 
                width: { xs: '100%', md: '60%' },
                height: '100%',
                borderRadius: 1,
                overflow: 'hidden',
                position: 'relative'
              }}>
                {locations[selectedLocation]?.coordinates && (
                  <MapContainer
                    center={locations[selectedLocation].coordinates}
                    zoom={13}
                    style={{ height: '100%', width: '100%' }}
                  >
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    
                    <MapController coordinates={locations[selectedLocation].coordinates} />
                    
                    <Marker 
                      position={locations[selectedLocation].coordinates}
                      icon={customIcon}
                    >
                      <Popup>
                        <div style={{ textAlign: 'center' }}>
                          <Typography sx={{ fontWeight: 600, mb: 1 }}>
                            {locations[selectedLocation].name}
                          </Typography>
                          <Typography sx={{ mb: 1, fontSize: '0.9rem' }}>
                            {locations[selectedLocation].address}
                          </Typography>
                        </div>
                      </Popup>
                    </Marker>
                  </MapContainer>
                )}

                {locations[selectedLocation]?.coordinates && (
                  <Box
                    component="a"
                    href={`https://www.google.com/maps/dir/?api=1&destination=${locations[selectedLocation].coordinates[0]},${locations[selectedLocation].coordinates[1]}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      position: 'absolute',
                      bottom: 5,
                      left: 5,
                      zIndex: 1000,
                      backgroundColor: '#51DF94',
                      color: 'white',
                      padding: '8px 16px',
                      borderRadius: '4px',
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: '#00B26C',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                      }
                    }}
                  >
                    <DirectionsIcon sx={{ fontSize: 20 }} />
                    <Typography
                      sx={{
                        fontSize: '0.9rem',
                        fontWeight: 500
                      }}
                    >
                      Como chegar
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>

          <Box sx={{ mt: 4, mb: 4 }}>
            {selectedDate && locations[selectedLocation] && (
              <>
                <Typography variant="h6" sx={{ fontWeight: 400, mb: 1.5, color: '#012F47' }}>
                  Resumo
                </Typography>

                <Box sx={{ 
                  bgcolor: 'white',
                  borderRadius: 2,
                  p: { xs: 2, md: 3 },
                  width: '100%'
                }}>
                  <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'flex-start', sm: 'center' },
                    gap: { xs: 2, sm: 3 }
                  }}>
                    {/* Card da data */}
                    <Paper
                      elevation={0}
                      sx={{
                        width: 70,
                        height: 70,
                        bgcolor: 'white',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 2,
                        border: '2px solid #012F47',
                        alignSelf: { xs: 'center', sm: 'flex-start' }
                      }}
                    >
                      <Typography sx={{ fontWeight: 700, fontSize: '1.5rem', lineHeight: 1 }}>
                        {selectedDate.day}
                      </Typography>
                      <Typography sx={{ fontWeight: 700, fontSize: '0.9rem' }}>
                        {selectedDate.month}
                      </Typography>
                    </Paper>

                    {/* Informações */}
                    <Box sx={{ 
                      flex: 1,
                      width: { xs: '100%', sm: 'auto' }
                    }}>
                      <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'flex-start',
                        gap: 1, 
                        mb: 1,
                        flexWrap: 'wrap'
                      }}>
                        <img 
                          src={LocationIcon}
                          alt="Localização"
                          style={{
                            width: '16px',
                            height: '16px',
                            objectFit: 'contain',
                            marginTop: '4px'
                          }}
                        />
                        <Typography sx={{ 
                          color: '#536777', 
                          fontSize: '0.9rem',
                          flex: 1
                        }}>
                          {locations[selectedLocation].address}
                        </Typography>
                      </Box>

                      <Box sx={{ 
                        display: 'flex', 
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'flex-start', sm: 'center' },
                        gap: { xs: 1, sm: 2 }
                      }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <img 
                            src={CalendarIcon}
                            alt="Calendário"
                            style={{
                              width: '16px',
                              height: '16px',
                              objectFit: 'contain'
                            }}
                          />
                          <Typography sx={{ color: '#536777', fontSize: '0.9rem' }}>
                            {formatDateToExtensive(selectedDate.day, selectedDate.month)}
                          </Typography>
                        </Box>
                        
                        <Box sx={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: 1,
                          ml: { xs: 0, sm: 2 }
                        }}>
                          <img 
                            src={ClockIcon}
                            alt="Relógio"
                            style={{
                              width: '16px',
                              height: '16px',
                              objectFit: 'contain'
                            }}
                          />
                          <Typography sx={{ color: '#536777', fontSize: '0.9rem' }}>
                            {selectedTime}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Botão Avançar */}
                    <Box
                      component="button"
                      onClick={handleScheduling}
                      sx={{
                        bgcolor: '#51DF94',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        py: 1.5,
                        px: 4,
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        width: { xs: '100%', sm: 'auto' },
                        mt: { xs: 2, sm: 0 },
                        '&:hover': {
                          bgcolor: '#00B26C',
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                        }
                      }}
                    >
                      <Typography sx={{ fontWeight: 500 }}>
                        Avançar
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Schedule;
